export default __webpack_public_path__ + "static/media/dbd.d192c9b7.svg";